<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top mb-4 shadow">
        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none d-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
        </button>

        <router-link to="/home" style="padding-right: 7px;" class="mr-5">
            <img
                alt="logo"
                src="../assets/01_logo_CBfull_principal.png"
                height="40"
                style="margin-top: 5px; margin-bottom: 5px; width: 70px; height: auto;"
                class="d-inline-block align-top"
            />
        </router-link>

        

        <button
            class="btn btn-link d-lg-none"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <i class=" fa fa-bars"></i>
        </button>

        
        <!-- Nav Item - Dashboard -->
        <div class="collapse navbar-collapse pl-5 ml-5" id="navbarSupportedContent">

            <div class="m-auto">
                THORPE - FECHAMENTO
            </div>

            <!-- Topbar Navbar -->
            <ul class="navbar-nav">
                <div class="dropdown-divider border-gray"></div>

                <div class="dropdown-divider border-gray"></div>

                <!-- Nav Item - User Information -->
                <li class="nav-item dropdown d-lg-inline no-arrow">
                    <a
                        class="nav-link dropdown-toggle "
                        role="button"
                        href="#"
                        id="userDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i class="fa fa-fw fa-user-circle mr-2"></i>
                        <span class="d-lg-inline"> {{ username }}</span>
                    </a>
                    <!-- Dropdown - User Information -->
                    <div
                        class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                        aria-labelledby="userDropdown"
                    >
                        <div class="dropdown-divider border-gray"></div>
                        <a class="dropdown-item" href="#" data-toggle="modal" data-target="#logoutModal">
                            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
                            Sair
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import { getUsername } from "../services/api";
export default {
    name: "Topbar",
    computed: {
        username: function() {
            return getUsername().split(" ")[0];
        },
    },
};
</script>

<style lang="scss" scoped>
a.disabled {
    opacity: 0.5;
}

a {
    font-size: 0.95em;
}
a.dropdown-item {
    color: var(--gray) !important;
}
a.dropdown-item:active {
    color: var(--white) !important;
}
</style>
